import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    originalValue: String,
    isExpired: Boolean
  }

  static targets = ['statusSelect']

  declare originalValueValue: string
  declare isExpiredValue: boolean
  declare statusSelectTarget: HTMLSelectElement

  connect (): void {
    // Listen for confirmation event from modal button
    document.addEventListener('evidence-status-confirmed', this.handleConfirmed as EventListener)
  }

  disconnect (): void {
    document.removeEventListener('evidence-status-confirmed', this.handleConfirmed as EventListener)
  }

  checkFormSubmit (event: Event): void {
    const form = this.element as HTMLFormElement

    // If already confirmed (set by modal button), allow submission
    if (form.dataset.confirmed === 'true') {
      delete form.dataset.confirmed
      return
    }

    const select = this.statusSelectTarget
    const newStatus = select.value

    // Only show confirmation if the evidence was expired and user is changing to a new non-expired status
    if (this.isExpiredValue && this.originalValueValue === 'expired' && newStatus !== 'expired' && newStatus !== '') {
      event.preventDefault()
      event.stopPropagation()
      this.showConfirmationModal(select, newStatus)
    }
  }

  private showConfirmationModal (select: HTMLSelectElement, newStatus: string): void {
    const modal = document.getElementById('evidence-status-confirmation-modal') as HTMLDialogElement
    if (modal == null) {
      return
    }

    // Update modal message with the new status
    const messageElement = modal.querySelector('[data-status-message]')
    if (messageElement != null) {
      const statusLabel = select.options[select.selectedIndex].text
      const baseMessage = 'This evidence has expired based on its Valid Until date. You are about to update to {NewStatus}. Do you want to continue?'
      messageElement.textContent = baseMessage.replace('{NewStatus}', statusLabel)
    }

    // Store the new status value and form reference for confirmation
    modal.dataset.newStatus = newStatus
    modal.dataset.selectId = select.id

    // Show the modal
    modal.showModal()
  }

  private readonly handleConfirmed = (event: Event): void => {
    const customEvent = event as CustomEvent<{ selectId: string, newStatus: string }>
    const { selectId, newStatus } = customEvent.detail
    const select = document.getElementById(selectId) as HTMLSelectElement

    if (select != null && newStatus !== '' && newStatus != null) {
      select.value = newStatus
    }

    // Set confirmed flag and submit the form
    const form = this.element as HTMLFormElement
    form.dataset.confirmed = 'true'

    // Use requestSubmit which properly submits the form without triggering click events on other buttons
    setTimeout(() => {
      form.requestSubmit()
    }, 100)
  }
}
